
import NavigationContainer from "./NavigationContainer";
import NavigationStore from "./NavigationStore";

export default NavigationStore(NavigationContainer); 
